var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table-responsive" }, [
    _c("table", [
      _c("thead", [
        _c("tr", [
          _c("th", [_vm._v("Nombre de campo")]),
          _vm._v(" "),
          _c("th", [_vm._v("Descripción")]),
          _vm._v(" "),
          _c(
            "th",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.enviable,
                  expression: "enviable"
                }
              ]
            },
            [_vm._v("SRI")]
          ),
          _vm._v(" "),
          _c("th", { staticClass: "ta-right" }, [
            _c(
              "button",
              {
                staticClass: "btn-success",
                attrs: { disabled: _vm.disabled, type: "button" },
                on: { click: _vm.agregarInformacionAdicional }
              },
              [_c("i", { staticClass: "fa fa-plus" })]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        [
          _vm._l(_vm.modelValue, function(row, index) {
            return _c("tr", { key: index }, [
              _c(
                "td",
                {
                  attrs: {
                    valign: "top",
                    tooltip:
                      row.nombre_campo !== "" ? row.nombre_campo : "Digite..."
                  }
                },
                [
                  _c(
                    "input-field",
                    {
                      attrs: {
                        disabled:
                          _vm.disabled ||
                          _vm.esObservacion(row) ||
                          _vm.esFechaVencimiento(row) ||
                          _vm.esRucProveedor(row),
                        placeholder: "Campo",
                        id: "campo" + index
                      },
                      on: {
                        input: function($event) {
                          return _vm.$emit("input", _vm.modelValue)
                        }
                      },
                      model: {
                        value: row.nombre_campo,
                        callback: function($$v) {
                          _vm.$set(row, "nombre_campo", $$v)
                        },
                        expression: "row.nombre_campo"
                      }
                    },
                    [
                      _vm.erroresFormulario.hasOwnProperty(
                        "informacionAdicional." + index + ".nombre_campo"
                      )
                        ? _c(
                            "span",
                            {
                              staticClass: "helper-text text-danger",
                              attrs: { slot: "helper" },
                              slot: "helper"
                            },
                            [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.erroresFormulario[
                                      "informacionAdicional." +
                                        index +
                                        ".nombre_campo"
                                    ][0]
                                  )
                                )
                              ])
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  attrs: {
                    valign: "top",
                    tooltip:
                      row.valor_campo !== "" ? row.valor_campo : "Digite..."
                  }
                },
                [
                  _c(
                    "textarea-field",
                    {
                      attrs: {
                        placeholder: "Escriba una observación...",
                        disabled:
                          _vm.disabled ||
                          _vm.esFechaVencimiento(row) ||
                          _vm.esRucProveedor(row),
                        id: "valorCampo" + index
                      },
                      on: {
                        input: function($event) {
                          return _vm.$emit("input", _vm.modelValue)
                        }
                      },
                      model: {
                        value: row.valor_campo,
                        callback: function($$v) {
                          _vm.$set(row, "valor_campo", $$v)
                        },
                        expression: "row.valor_campo"
                      }
                    },
                    [
                      _vm.erroresFormulario.hasOwnProperty(
                        "informacionAdicional." + index + ".valor_campo"
                      )
                        ? _c(
                            "span",
                            {
                              staticClass: "helper-text text-danger",
                              attrs: { slot: "helper" },
                              slot: "helper"
                            },
                            [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.erroresFormulario[
                                      "informacionAdicional." +
                                        index +
                                        ".valor_campo"
                                    ][0]
                                  )
                                )
                              ])
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.enviable,
                      expression: "enviable"
                    }
                  ]
                },
                [
                  _c("p", [
                    _c("label", { attrs: { for: "sriEnviable" + index } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.modelValue[index].enviar_sri,
                            expression: "modelValue[index].enviar_sri"
                          }
                        ],
                        attrs: {
                          disabled:
                            _vm.esObservacion(row) || _vm.esRucProveedor(row),
                          type: "checkbox",
                          id: "sriEnviable" + index
                        },
                        domProps: {
                          checked: Array.isArray(
                            _vm.modelValue[index].enviar_sri
                          )
                            ? _vm._i(_vm.modelValue[index].enviar_sri, null) >
                              -1
                            : _vm.modelValue[index].enviar_sri
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.modelValue[index].enviar_sri,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.modelValue[index],
                                    "enviar_sri",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.modelValue[index],
                                    "enviar_sri",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.modelValue[index], "enviar_sri", $$c)
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span")
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c("td", [
                _c(
                  "button",
                  {
                    staticClass: "btn-danger btn--text",
                    attrs: {
                      disabled:
                        _vm.disabled ||
                        _vm.esObservacion(row) ||
                        _vm.esRucProveedor(row),
                      type: "button"
                    },
                    on: {
                      click: function($event) {
                        return _vm.eliminarInformacionAdicional(index)
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-trash-o" })]
                )
              ])
            ])
          }),
          _vm._v(" "),
          _c(
            "tr",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.modelValue.length === 0,
                  expression: "modelValue.length === 0"
                }
              ]
            },
            [
              _c("td", { attrs: { colspan: _vm.enviable ? 4 : 3 } }, [
                _c("strong", [
                  _vm._v("No se ha agregado información adicional.")
                ])
              ])
            ]
          )
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38e1566a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38e1566a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/TablaInformacionAdicional.vue
// module id = 390
// module chunks = 0